export const AGENT_ID = 'agentId';
export const AWAY_MODE = 'awayMode';
export const PORTAL_ID = 'portalId';
export const UPDATED_BY_AGENT_ID = 'updatedByAgentId';
export const UPDATED_AT = 'updatedAt';